import React from 'react';
import Projects from '../Projects/Projects';
import Banner from '../Banner/Banner';
import Footer from '../Footer/Footer';
import About from '../About/About';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import { useEffect } from 'react';
const Home = () => {
    useEffect(() => {
        AOS.init({
            duration: 2500,
            once: false
        });
        AOS.refresh()
    }, [])

    return (
        <div>
            {/* Spinner */}
            {/* <div style={{ backgroundColor: '#141c3a' }}>
                        <div className="spinner d-flex align-items-center justify-content-center">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                        </div>
                    </div> */}
            <div>

                <Banner></Banner>
                <div style={{ backgroundColor: 'black', paddingBottom: '200px' }}>
                    <Projects></Projects>
                    <About></About>
                </div>
                <Footer></Footer>
            </div>


        </div>
    );
};

export default Home;